module.exports = __webpack_public_path__ + "static/favicon/android-chrome-256x256.png";